"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
// import { message } from "antd";
const auth_utils_1 = require("@star-charge/auth-utils");
const store_1 = require("../../store");
// const errorMessage = (msg: string) => {
//   message.error(msg);
// };
axios_1.default.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios_1.default.defaults.timeout = 30000;
axios_1.default.defaults.withCredentials = true;
// const codeHandlers: Record<string, any> = {
//   S00000: "成功",
//   E00001: "系统错误",
//   E00002: "网络异常",
//   E00003: "请求参数错误",
//   E00004: "验证失败",
//   E00005: [
//     "您还未登录",
//     () => {
//       ssoRedirectFunction();
//     },
//   ],
//   E00006: "数据已过期",
//   E00007: "权限不足",
//   E00008: "次数超过限制",
//   E00009: "频次超限",
//   E00010: "资源或者数据不存在",
//   E00011: "资源或者数据已经存在",
//   E00012: "格式不合法",
//   E00013: "请求被限制或者拒绝",
//   E00014: "数据格式错误",
//   E00015: "功能已不支持",
//   E00016: "数据或版本不匹配",
// };
// 添加请求拦截器
axios_1.default.interceptors.request.use(function (config) {
    const store = (0, store_1.useLoadingStore)();
    store.loading = true;
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    const store = (0, store_1.useLoadingStore)();
    store.loading = false;
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 错误拦截
axios_1.default.interceptors.response.use((res) => {
    var _a;
    const store = (0, store_1.useLoadingStore)();
    store.loading = false;
    // const code = res.data?.code;
    // const codeHandle = codeHandlers[code];
    // if (codeHandle instanceof Array && codeHandle[1]) {
    //   codeHandle[1]();
    //   return Promise.reject(res);
    // } else if (code !== "S00000") {
    //   errorMessage(res.data?.message || res.data?.error || codeHandle);
    //   return Promise.reject(res);
    // }
    const model = (_a = res.data) === null || _a === void 0 ? void 0 : _a.model;
    // 判断如果是分页请求，则拼接参数
    if (model === null || model === void 0 ? void 0 : model.query) {
        res.data.total = res.data.model.amount;
        res.data.data = res.data.model.result;
        res.data.pageSize = res.data.model.query.pageSize;
    }
    return res.data;
}, (error) => {
    const store = (0, store_1.useLoadingStore)();
    store.loading = false;
    try {
        const fromNameFull = error.config.url;
        if ((error === null || error === void 0 ? void 0 : error.status) === 403) {
            (0, auth_utils_1.ssoRedirectFunction)();
            return;
        }
        // 判断错误性质
        let diagnose = "";
        if (error.response && error.request) {
            diagnose = "🔌[请求已完成但服务端报错]";
        }
        if (!error.response && error.request) {
            diagnose = "😰[请求未发出就出错]";
        }
        const CSS_1 = "padding: 0 10px;border-radius: 4px;background:rgba(239, 0, 0,.5); color:#fff;";
        const CSS_2 = "padding: 0 10px;border-radius: 4px;background: rgba(239, 212, 212,.1);";
        console.log(`%c[APIError]%c - %c ${fromNameFull} %c\n`, CSS_1, "", CSS_2, ";", diagnose + "\n", error);
        return Promise.reject(error);
    }
    catch ($error) {
        return Promise.reject($error);
    }
});
exports.default = axios_1.default;
